import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchRestaurantById } from "../../store/restaurant-slice"; // Adjust to your actual action import
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/restaurantModel";
import {getValidatedLimit} from "../../components/Utility"; // Adjust to your actual model import

const RestaurantDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.restaurant);
    const {limit, currentPage} = getValidatedLimit(pagination);

    useEffect(() => {
        dispatch(fetchRestaurantById(params.restaurantId)); // Adjust based on your actual Redux action
    }, [dispatch, params.restaurantId]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.restaurant); // Adjust based on your Redux slice


    const item = items.find(item => item.id === params.restaurantId); // Ensure correct id matching
    const detailData = getDetailData({ item }); // Adjust this to fit how you process data for details

    return (
        <>
            <SubHeader title="Restaurant Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`} className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default RestaurantDetail;
